import type {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import {Languages} from '@freckle/educator-entities/ts/common/helpers/languages'
import type {components} from '@freckle/educator-entities/ts/curricula-api/generated-client'
import {curriculaClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type LanguageT = components['schemas']['Language'] & {language: LangT}

const parseLanguageT = (raw: components['schemas']['Language']): LanguageT => ({
  ...raw,
  language: Languages.unsafeParse(raw.language)
})

// Fetch languages. The `language` parameter forces the language from which
// other languages will be viewed. This is useful when, for example, a user has
// just changed their language and we need to re-fetch the list of languages
export const fetchLanguages = (language: LangT): Promise<Array<LanguageT>> =>
  curriculaClient
    .GET(`/languages`, {params: {query: {language}}})
    .then(extractData)
    .then(d => d.languages.map(parseLanguageT))
